// src/features/components/iconPacks/index.ts
export * from './types';
export * from './IconPackManager';
import { iconPackManager } from './IconPackManager';
import type { IconPack } from './types';

/**
 * Register all icon pack loaders (lazy loading)
 * Packs will be loaded on-demand when requested
 */
export function registerAllIconPacks(): void {
    // Register AWS pack loader (428 icons)
    iconPackManager.registerPackLoader(
        'aws',
        'AWS',
        'cloud-provider',
        428,
        async () => {
            const module = await import('./awsPack');
            return module.awsPack;
        }
    );

    // Register Azure pack loader (693 icons)
    iconPackManager.registerPackLoader(
        'azure',
        'Azure',
        'cloud-provider',
        693,
        async () => {
            const module = await import('./azurePack');
            return module.azurePack;
        }
    );

    // Register GCP pack loader (25 icons)
    iconPackManager.registerPackLoader(
        'gcp',
        'GCP',
        'cloud-provider',
        25,
        async () => {
            const module = await import('./gcpPack');
            return module.gcpPack;
        }
    );

    // Register Kubernetes pack loader (39 icons)
    iconPackManager.registerPackLoader(
        'kubernetes',
        'Kubernetes',
        'cloud-provider',
        39,
        async () => {
            const module = await import('./kubernetesPack');
            return module.kubernetesPack;
        }
    );

    // Register Custom isometric icon pack
    iconPackManager.registerPackLoader(
        'custom',
        'Custom Isometric',
        'custom',
        76, // 76 isometric icons
        async () => {
            try {
                const module = await import('./customPack');
                return module.customPack;
            } catch (error) {
                console.warn('⚠️  Custom icon pack not found.');
                // Return empty pack as fallback
                return {
                    id: 'custom',
                    name: 'Custom Isometric',
                    description: 'Custom isometric icons',
                    source: 'custom',
                    categories: [],
                    icons: []
                } as IconPack;
            }
        }
    );
}

// Auto-register loaders on module import
registerAllIconPacks();

// Re-export the singleton
export { iconPackManager };
